export class ContentFlightStatus {
  orLabel: any;
  toLabel: any;
  fromLabel: any;
  searchByLabel: any;
  flightNumber: any;
  id: any;
  label: any;
  searchByLabelFloat: any;
  flightNumberLabelFloat: any;
  flightNumberType: any;
  helpUrl: any;
  helpLabel: any;
  toLabelFloat: any;
  fromLabelFloat: any;
  flightstatusRegexPattern: any;
  submitUrl: any;
  legacyAppUrl: string;
  flightStatusSubmitUrl: string;
  flightScheduleSubmitUrl: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['orLabel']) {
        this.orLabel = contentjson['orLabel'];
      }
      if (contentjson['toLabel']) {
        this.toLabel = contentjson['toLabel'];
      }
      if (contentjson['fromLabel']) {
        this.fromLabel = contentjson['fromLabel'];
      }
      if (contentjson['searchByLabel']) {
        this.searchByLabel = contentjson['searchByLabel'];
      }
      if (contentjson['flightNumber']) {
        this.flightNumber = contentjson['flightNumber'];
      }
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['searchByLabelFloat']) {
        this.searchByLabelFloat = contentjson['searchByLabelFloat'];
      }
      if (contentjson['flightNumberLabelFloat']) {
        this.flightNumberLabelFloat = contentjson['flightNumberLabelFloat'];
      }
      if (contentjson['flightNumberType']) {
        this.flightNumberType = contentjson['flightNumberType'];
      }
      if (contentjson['toLabelFloat']) {
        this.toLabelFloat = contentjson['toLabelFloat'];
      }
      if (contentjson['fromLabelFloat']) {
        this.fromLabelFloat = contentjson['fromLabelFloat'];
      }
      if (contentjson['submitUrl']) {
        this.submitUrl = contentjson['submitUrl'];
      }
      if (contentjson['helpUrl']) {
        this.helpUrl = contentjson['helpUrl'];
      }
      if (contentjson['helpLabel']) {
        this.helpLabel = contentjson['helpLabel'];
      }
      if (contentjson['flightstatusRegexPattern']) {
        this.flightstatusRegexPattern = contentjson['flightstatusRegexPattern'];
      }
      if (
        contentjson['legacyAppUrl'] &&
        contentjson['legacyAppUrl'].trim() !== ''
      ) {
        this.legacyAppUrl = contentjson['legacyAppUrl'];
      }
      if (
        contentjson['flightStatusSubmitUrl'] &&
        contentjson['flightStatusSubmitUrl'].trim() !== ''
      ) {
        this.flightStatusSubmitUrl = contentjson['flightStatusSubmitUrl'];
      }
      if (
        contentjson['flightScheduleSubmitUrl'] &&
        contentjson['flightScheduleSubmitUrl'].trim() !== ''
      ) {
        this.flightScheduleSubmitUrl = contentjson['flightScheduleSubmitUrl'];
      }
    }
  }
}
